import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push (location) {
//   return originalPush.call(this, location).catch(err => err)
// }
const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login')
  },
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/home')
  },
  {
    path: '/changepassword',
    name: 'changepassword',
    component: () => import('@/views/changepassword')
  },
  {
    path: '/membermanagement',
    name: 'membermanagement',
    component: () => import('@/views/membermanagement')
  },
  {
    path: '/newmembers',
    name: 'newmembers',
    component: () => import('@/views/newmembers')
  },
  {
    path: '/financing',
    name: 'financing',
    redirect: '/financing/project',
    component: () => import('@/views/financing'),
    children: [{
      path: '/financing/project',
      name: 'project',
      component: () => import('@/views/financing/project')
    }, {
      path: '/financing/needs',
      name: 'needs',
      component: () => import('@/views/financing/needs')
    }]
  },
  {
    path: '/ordermanagement',
    name: 'ordermanagement',
    component: () => import('@/views/Ordermanagement')
  },
  {
    path: '/evaluationmanagement',
    name: 'evaluationmanagement',
    component: () => import('@/views/Evaluationmanagement')
  },
  {
    path: '/personaldata',
    name: 'personaldata',
    component: () => import('@/views/personaldata')
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'hash',
  // base: process.env.BASE_URL,
  routes
})
// 全局路由守卫
router.beforeEach((to, from, next) => {
  // to: Route: 即将要进入的目标 路由对象
  // from: Route: 当前导航正要离开的路由
  // next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。

  const nextRoute = ['home', 'changepassword', 'membermanagement', 'newmembers', 'financing', 'ordermanagement', 'evaluationmanagement', 'personaldata']
  const isLogin = JSON.parse(window.localStorage.getItem('token')) // 是否登录
  // 未登录状态；当路由到nextRoute指定页时，跳转至login
  if (nextRoute.indexOf(to.name) !== -1) {
    if (!isLogin) {
      router.push('/login')
    } else {
      next()
    }
  } else {
    next()
  }
  if (to.name === 'login') {
    if (isLogin) {
      router.push({ name: 'home' })
    }
  }
  next()
})
export default router
